"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartiuClient = void 0;
const axios_1 = require("axios");
const api_1 = require("./modules/api");
const auth_1 = require("./modules/auth");
const banner_1 = require("./modules/banner");
const categories_1 = require("./modules/categories");
const contact_1 = require("./modules/contact");
const integrations_1 = require("./modules/integrations");
const location_1 = require("./modules/location");
const profile_1 = require("./modules/profile");
const promotions_1 = require("./modules/promotions");
const referral_1 = require("./modules/referral");
const sales_1 = require("./modules/sales");
const validate_1 = require("./modules/validate");
class PartiuClient {
    constructor(staging = false) {
        const that = this;
        this.axiosInstance = axios_1.default.create({
            baseURL: this._getBaseURL(staging),
            validateStatus: (status) => {
                if (status === 401) {
                    that.logout();
                }
                return status >= 200 && status < 400;
            },
        });
        this.auth = new auth_1.default(this.axiosInstance);
        this.categories = new categories_1.default(this.axiosInstance);
        this.contact = new contact_1.default(this.axiosInstance);
        this.promotions = new promotions_1.default(this.axiosInstance);
        this.profile = new profile_1.default(this.axiosInstance);
        this.salesApp = new sales_1.default(this.axiosInstance);
        this.banners = new banner_1.default(this.axiosInstance);
        this.api = new api_1.default(this.axiosInstance);
        this.integrations = new integrations_1.IntegrationModule(this.axiosInstance);
        this.referral = new referral_1.default(this.axiosInstance);
        this.validate = new validate_1.ValidateModule(this.axiosInstance);
        this.location = new location_1.LocationModule();
    }
    login(token) {
        this.axiosInstance.defaults.headers.common["Authorization"] = `TOKEN ${token}`;
    }
    logout() {
        delete this.axiosInstance.defaults.headers.common["Authorization"];
    }
    _getBaseURL(staging) {
        let baseURL;
        if (staging)
            baseURL = "https://api.staging.partiu.com.br";
        else
            baseURL = "https://api.partiu.com.br";
        return baseURL;
    }
}
exports.PartiuClient = PartiuClient;
//# sourceMappingURL=index.js.map